import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const STATISTIC_SCHEMA = Object.freeze({
  NUMBER_OF_REVIEWS: 0,
});
export const RECORD = generateSchema(STATISTIC_SCHEMA);
export const KEYS: any = generateKeys(STATISTIC_SCHEMA);

export class Statistic extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);
  }

  get numberOfReviews(): number {
    return this.get(KEYS.NUMBER_OF_REVIEWS);
  }
}
